import { Route } from '@playbooks/ui/components/route';

import { IndexSplashFooter } from 'mkt/index/index-splash-footer';
import { IndexSplashHeader } from 'mkt/index/index-splash-header';
import { IndexSplashHero } from 'mkt/index/index-splash-hero';

const IndexSplash = ({ contacts = [] }) => (
	<Route
		seo={{
			title: 'Playbooks | Transform ideas into products.',
			description:
				'Playbooks is an AI-native platform that helps entrepreneurs, business owners, and operators transform ideas into intelligent products.',
		}}
		className='min-h-screen bg-canvas text-white'>
		<div className='mx-auto flex min-h-screen w-full max-w-xxl flex-col border-x border-border'>
			<IndexSplashHeader />
			<main className='flex-column w-full grow'>
				<IndexSplashHero contacts={contacts} />
			</main>
			<IndexSplashFooter />
		</div>
	</Route>
);
export { IndexSplash };
